<div class="row mt-3 description">
  <div class="col-md-12 d-flex">
    <img
      src="/assets/img/description.png"
      class="icon-dimension icon-description"
      alt="description"
    />
    &nbsp;
    <p class="text-uppercase pt-2">
      <b>{{ "IDS_DESCRIPTION" | translate }}</b>
    </p>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="description-page" [innerHTML]="description()"></div>
    </div>
  </div>
  @if(!isEventNow() && !isCertificatePage() && !!notes()){
  <div class="col-md-12 mt-4 d-flex">
    <img
      src="/assets/img/insurance.png"
      class="icon-dimension"
      alt="insurance"
    />
    &nbsp;
    <p class="text-uppercase">
      <b>{{ "IDS_DISCLAIMER" | translate }}</b>
    </p>
  </div>
  <div class="row notes">
    <div class="col-md-12">
      <div class="description-page" [innerHTML]="notes()"></div>
    </div>
  </div>
  }
</div>

<div class="row mt-4 description--mobile">
  <div class="col-12 mb-2 d-flex justify-content-between">
    @if(!descriptionClicked()){
    <button
      (click)="onDescription()"
      class="text-uppercase"
      [ngClass]="{
        'button-clicked-gold': isMemorabid(),
        'button-clicked-marketplace': !isMemorabid()
      }"
    >
      <img
        src="/assets/img/description.png"
        class="icon-dimension"
        alt="description"
      />
      {{ "IDS_DESCRIPTION" | translate }}
    </button>

    @if(!isEventNow() && !isCertificatePage() && !!notes()){
    <button (click)="onDisclaimer()" class="text-uppercase me-4">
      <img
        src="/assets/img/insurance.png"
        class="icon-dimension"
        alt="insurance"
      />
      {{ "IDS_DISCLAIMER" | translate }}
    </button>
    } } @else {
    <button (click)="onDescription()" class="text-uppercase">
      <img
        src="/assets/img/description.png"
        class="icon-dimension"
        alt="description"
      />
      {{ "IDS_DESCRIPTION" | translate }}
    </button>
    @if(!isEventNow() && !isCertificatePage() && !!notes()){
    <button
      (click)="onDisclaimer()"
      class="text-uppercase me-4"
      [ngClass]="{
        'button-clicked-gold': isMemorabid(),
        'button-clicked-marketplace': !isMemorabid()
      }"
    >
      <img
        src="/assets/img/insurance.png"
        class="icon-dimension"
        alt="insurance"
      />
      {{ "IDS_DISCLAIMER" | translate }}
    </button>
    } }
  </div>

  @if(!descriptionClicked()){
  <div class="row">
    <div class="description-page" [innerHTML]="description()"></div>
  </div>
  } @else if (!isEventNow() && !isCertificatePage()) {

  <div class="row">
    <div class="description-page" [innerHTML]="notes()"></div>
  </div>
  }
</div>
